export default "__VITE_ASSET__Ch46KjN___"